import React, { Fragment } from "react";

import GreenLogo from "../Innovators/GreenLogo";

const BefriendConfirm = ({
  befriendedUser,
  setShowBefriend,
  user: { avatar, firstname, lastname, jobtitle, location },
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="subscription-box-confirmation">
          <i
            className="far fa-times-circle green fa-3x subscription-x"
            onClick={() => setShowBefriend({ request: false, confirm: false })}
          ></i>
          <div className="subscription-type-container">
            <p className="nav-logo">
              <GreenLogo />
            </p>
            <h1 className="subscription-name green">Friend Added</h1>
          </div>
          <div className="sub-grid-three">
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i className="fas fa-user-circle mr-5 fa-lg mt-5 green"></i>
                  <p className="sub-section green">Friend added:</p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div className="avi-color-border-alt green">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                      className="sub-avi"
                      alt="avi"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font bold">
                        {firstname} {lastname}
                      </span>
                    </li>
                    <li className="user-online-item">{jobtitle}</li>
                    <li className="user-online-item">
                      {location.city}, {location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="subscription-user">
              <div className="sub-section-container">
                <div className="flex-only">
                  <i className="fas fa-user-circle mr-5 fa-lg mt-5 green"></i>
                  <p className="sub-section green">Friend added:</p>
                </div>
              </div>
              <div className="sub-user">
                <div className="online-avi-container">
                  <div className="avi-color-border-alt green">
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${befriendedUser.avatar}`}
                      className="sub-avi"
                      alt="avi-two"
                    />
                  </div>
                </div>
                <div className="sub-info">
                  <ul className="user-online-items">
                    <li className="user-online-item">
                      <span className="green name-font bold">
                        {befriendedUser.firstname} {befriendedUser.lastname}
                      </span>
                    </li>
                    <li className="user-online-item">
                      {befriendedUser.jobtitle}
                    </li>
                    <li className="user-online-item">
                      {befriendedUser.location.city},{" "}
                      {befriendedUser.location.state}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="sub-grid">
            <p className="user-request-text">
              You are now friends with {befriendedUser.firstname}{" "}
              {befriendedUser.lastname}
            </p>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default BefriendConfirm;
